import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PviDialogComponent } from '../../pvi/pvi-dialog/pvi-dialog.component';
import { filter, tap } from 'rxjs/operators';
import { InsuranceService } from '../../../services/insurance.service';

@Component({
  selector: 'gtd-insurance-widget',
  templateUrl: './insurance-widget.component.html',
  styleUrls: ['./insurance-widget.component.scss']
})
export class InsuranceWidgetComponent implements OnInit {
  @Input() title: string;
  @Input() description: string;
  @Input() imageUrl: string;
  @Input() note: string;
  @Input() onlyVietnamesePeople = false;
  checked = this.insuranceService.checked;
  constructor(
    private dialog: MatDialog,
    private insuranceService: InsuranceService
  ) {}

  ngOnInit() {}

  onCheckedChange(event) {
    this.insuranceService.checked = event;
    if (!this.checked) {
      this.insuranceService.resetPlanSelected();
      this.insuranceService.setInsurer(null);
      return;
    }
    const dialogRef = this.dialog.open(PviDialogComponent, {
      autoFocus: false,
      disableClose: true
    });
    dialogRef
      .afterClosed()
      .pipe(
        filter(dialogResult => dialogResult && dialogResult.action == 'none'),
        tap(_ => (this.checked = false))
      )
      .subscribe();
  }
}
